import { inkFontTokens } from '@ds/tokens';
import styled from '@emotion/styled';

const FontBodyM = styled.div`
    ${inkFontTokens.fontBodyM}
`;

export default FontBodyM;
